var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCarDoor = function SvgCarDoor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 400,
    height: 400,
    viewBox: "0 0 100 100"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 45a276.756 276.756 0 0 0 5 45h70V60c.011-7.352.911-21.231 5-50-11.45.161-32.864 2.109-55 15-11.053 6.436-19.247 13.832-25 20Zm50 10a5 5 0 0 1 5-5h10a5 5 0 0 1 5 5H60Zm24.222-39.766c-1.6 11.722-2.747 21.66-3.439 29.766H30V34.164a103.217 103.217 0 0 1 7.516-4.843c14.005-8.156 30.044-12.979 46.706-14.087Z"
  })));
};

export default SvgCarDoor;